import React, {useCallback, useEffect, useState} from "react";
import {makeAccessor, makeHeader, prepareFilterQuery, prepareSortQuery} from "../../Utils/gridUtils";
import {IconButton, Tooltip} from "@mui/material";
import {CalendarTodaySharp, PersonAddAlt1, RemoveRedEyeSharp,} from "@mui/icons-material";
import {
    APPROVED,
    DELAY_TRANSFER, getUserSettings,
    PENDING,
    REVIEW,
    TRANSFER_LATER_CANCEL_NOW,
    TRANSFER_MEMBERSHIP
} from "../../Utils/constants";
import {getChangePersonJobs} from "../../../API/changePersonJob";
import {toast} from "react-toastify";
import GridElement from "../../Common/GridElement";
import DelayTransferMembershipModal from "./DelayTransferMembershipModal";
import TransferMembershipModal from "./TransferMembershipModal";
import {ERP_BASE_URL} from "../../../API/util";
import ReviewTransferMembershipRequest from "./ReviewTransferMembershipRequest";
import CapabilityChecker from "../../Common/CapabilityChecker";
import {showEllipsis} from "../../Utils/stringUtils";
import {DateRangeColumnFilter} from "../../Common/GridFilters/DateRangeColumnFilter";
import {DefaultColumnFilter} from "../../Common/GridFilters/DefaultColumnFilter";
import {updateUserSetting} from "../../../API/userSettings";

const TransferLaterGrid = () => {
    const {user, userMeta} = getUserSettings();
    const lastSortBy = user?.tableSettings?.person_job_changes?.sortBy ? user.tableSettings.person_job_changes.sortBy : null;

    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [pageCount, setPageCount] = React.useState(0);
    const [rowsCount, setRowsCount] = React.useState(0);
    const [filters, setFilters] = React.useState(() => {
        return user?.tableSettings?.person_job_changes?.filters ? user.tableSettings.person_job_changes.filters : [];
    });
    const [controlledPageIndex, setControlledPageIndex] = useState(0);
    const [openDelayTransferMembershipModal, setOpenDelayTransferMembershipModal] = useState(false);
    const [changeJob, setChangeJob] = useState({});
    const [openTransferMembershipModal, setOpenTransferMembershipModal] = useState(false);
    const [refreshGridData, setRefreshGridData] = useState(false);
    const [openReviewRequest, setOpenReviewRequest] = useState(false);
    const colLinks = [
        {
            'person_name': {"key": "person_id", "link": `${ERP_BASE_URL}/#/contacts/persons/:person_id`},
        },
        {
            'transfered_to': {
                "key": "transfered_to_person_id",
                "link": `${ERP_BASE_URL}/#/contacts/persons/:transfered_to_person_id`
            }
        },
    ];
    const colJson = ["transfer_history"];
    const [cols, setCols] = useState([]);

    useEffect(() => {
        let columns = userMeta.table_columns.person_job_changes;
        let visibleColumns = user.tableSettings.person_job_changes?.columns ? user.tableSettings.person_job_changes?.columns : [];
        let invisibleColumns = columns.filter((column) => !visibleColumns.includes(column));
        columns = [...visibleColumns, ...invisibleColumns];

        setCols(getVisibleColumns(columns, visibleColumns));
    }, []);

    const getVisibleColumns = (columns, visibleColumns) => {
        const dynamicColumns = columns?.map(key => {
            let visible= visibleColumns.includes(key);

            if (visibleColumns?.length === 0) {
                visible = true;
            }

            let col =  {
                column: key,
                accessor: makeAccessor(key),
                minWidth: 150,
                Header: makeHeader(key),
                filter: (isDateColumn(key)) ? 'dateRange' : 'fuzzyText',
                Filter: (isDateColumn(key)) ? DateRangeColumnFilter: DefaultColumnFilter,
                visible: visible,
                formatDate: isDateColumn(key)
            }

            if (key === "initiater_comments") {
                col["Cell"] = ({row}) => (
                    <div>
                        {
                            row.original.initiater_comments?.length >= 50 ? showEllipsis(row.original.initiater_comments, 50) : row.original.initiater_comments
                        }
                    </div>
                )
            }

            if (key === "reviewer_comments") {
                col["Cell"] = ({row}) => (
                    <div>
                        {
                            row.original.reviewer_comments?.length >= 50 ? showEllipsis(row.original.reviewer_comments, 50) : row.original.reviewer_comments
                        }
                    </div>
                );
            }

            return col;
        });

        dynamicColumns?.push({
                    minWidth: 150,
                    Header: makeHeader("Actions"),
                    filter: "fuzzyText",
                    Cell: ({row}) => (
                        <div>
                            {
                                row.original.status === PENDING &&
                                <>
                                    <CapabilityChecker capabilities={['can_review_transfer_membership_request']}>
                                        <Tooltip title={REVIEW} arrow placement='top'>
                                            <IconButton
                                                aria-label={REVIEW}
                                                aria-haspopup='true'
                                                onClick={() => {
                                                    setOpenReviewRequest(true);
                                                    setChangeJob(row.original);
                                                }}
                                                style={{
                                                    color: "#000",
                                                    fontSize: "17px",
                                                    fontWeight: "600",
                                                }}
                                            >
                                                <RemoveRedEyeSharp color='primary'/>
                                            </IconButton>
                                        </Tooltip>
                                    </CapabilityChecker>

                                </>
                            }
                            {
                                row.original.status === APPROVED && row.original.change_job_type === TRANSFER_LATER_CANCEL_NOW &&
                                <>

                                    <CapabilityChecker capabilities={['can_review_transfer_membership_request']}>
                                        <Tooltip title={DELAY_TRANSFER} arrow placement='top'>
                                            <IconButton
                                                aria-label={DELAY_TRANSFER}
                                                aria-haspopup='true'
                                                onClick={() => {
                                                    setOpenDelayTransferMembershipModal(true);
                                                    setChangeJob(row.original);
                                                }}
                                                style={{
                                                    color: "#000",
                                                    fontSize: "17px",
                                                    fontWeight: "600",
                                                }}
                                            >
                                                <CalendarTodaySharp color='primary'/>
                                            </IconButton>
                                        </Tooltip>
                                    </CapabilityChecker>
                                    <Tooltip title={TRANSFER_MEMBERSHIP} arrow placement='top'>
                                        <IconButton
                                            aria-label={TRANSFER_MEMBERSHIP}
                                            aria-haspopup='true'
                                            onClick={() => {
                                                setOpenTransferMembershipModal(true);
                                                setChangeJob(row.original);
                                            }}
                                            style={{
                                                color: "#000",
                                                fontSize: "17px",
                                                fontWeight: "600",
                                            }}
                                        >
                                            <PersonAddAlt1 color='primary'/>
                                        </IconButton>
                                    </Tooltip>
                                </>
                            }
                        </div>
                    )
                });

        return dynamicColumns ? [...dynamicColumns] : [];
    }

    const isDateColumn = (key) => {
        return (key === 'created_at' || key === 'tentative_transfer_date' || key === 'reviewed_at')
    }

    const fetchData = useCallback(({pageSize, pageIndex, sortBy, filters, columns}) => {
        let _columns = columns.filter((item) => item.visible).map((item) => item.column);
        _columns = _columns.filter((item) => item !== undefined);
        _columns.push('payload')

        let query = "",
            sort = "";

        query = query + prepareFilterQuery(filters, columns);
        sort = prepareSortQuery(sortBy, columns);

        setLoading(true);

        getChangePersonJobs({
            results: pageSize,
            columns: _columns,
            offset: pageIndex + 1,
            filter: query,
            sort: sort
        }).then(res => {
            setData(res.data.main);
            setPageCount(res.data.offset.highest_offset);
            setRowsCount(res.data.offset.rows_count);
            setLoading(false);
            updateUserSetting(getUserSettings()['user']).then(() => {});
        }).catch((error) => {
            toast.error(error);
            setLoading(false);
        })

        setRefreshGridData(false); //if grid fetches latest data then set refreshGridData to false
    }, []);

    const resetFilters = useCallback(() => setFilters([]), [setFilters]);

    const handleDelayTransferMembershipClose = (refreshGrid = false) => {
        setOpenDelayTransferMembershipModal(false);
        setRefreshGridData(refreshGrid);
    };

    const handleReviewRequestClose = () => {
        setOpenReviewRequest(false);
        setRefreshGridData(true);
    };

    const handleTransferMembershipClose = (refreshGrid = false) => {
        setOpenTransferMembershipModal(false);
        setRefreshGridData(refreshGrid);
    };

    return (
        <>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <h2 className='page-title'>Transfer Membership</h2>
            </div>

            <GridElement
                columns={cols}
                data={data}
                fetchData={fetchData}
                loading={loading}
                pageCount={pageCount}
                controlledPageIndex={controlledPageIndex}
                setControlledPageIndex={setControlledPageIndex}
                filters={filters}
                setFilters={setFilters}
                resetFilters={resetFilters}
                rowsCount={rowsCount}
                handleRowClick={() => {
                }}
                initialSortBy='created_at'
                sortOrder='desc'
                hideSelection={true}
                colLinks={colLinks}
                colJson={colJson}
                refreshGridData={refreshGridData}
                showColumnsControl={true}
                showCsvDownloadControl={true}
                setColumns={setCols}
                table="person_job_changes"
                lastSortBy={lastSortBy}
            />
            <DelayTransferMembershipModal
                changeJob={changeJob}
                open={openDelayTransferMembershipModal}
                handleClose={handleDelayTransferMembershipClose}/>
            <ReviewTransferMembershipRequest
                changeJob={changeJob}
                open={openReviewRequest}
                handleClose={handleReviewRequestClose}/>
            <TransferMembershipModal
                open={openTransferMembershipModal}
                handleClose={handleTransferMembershipClose}
                personId={changeJob.person_id}
                purchaseId={changeJob.purchase_id}
                transferLater={true}
                personChangeJobId={changeJob.person_job_change_id}/>
        </>
    );
}

export default TransferLaterGrid;